import React from 'react';
import BuyGood from "../../assets/buygoods_black.png"


const Footer = () => {
    return (
        <div>

            <footer className="bg-[#0E223B] text-white font-semibold gap-2 py-8 text-center text-sm">
                <div className="max-w-7xl mx-auto px-4">
                    {/* Navigation Links */}
                    <div className="flex flex-wrap justify-center space-x-6 mb-4">
                        <a href="#" className="hover:text-gray-300">Contact</a>
                        <a href="#" className="hover:text-gray-300">Terms</a>
                        <a href="#" className="hover:text-gray-300">Privacy</a>
                        <a href="#" className="hover:text-gray-300">Return Policy</a>
                        <a href="#" className="hover:text-gray-300">Disclaimer</a>
                    </div>

                    {/* Disclaimers */}
                    <p className="text-gray-400 text-xs mb-4 font-normal">
                        Statements on this website have not been evaluated by the Food and Drug Administration. Products are not intended to diagnose, treat, cure or prevent any disease.
                    </p>
                    <p className="text-gray-400 text-xs mb-4 font-normal">
                        The website's content and the product for sale is based upon the author's opinion and is provided solely on an "AS IS" and "AS AVAILABLE" basis. You should do your own research and
                        confirm the information with other sources when searching for information regarding health issues and always review the information carefully with your professional health care provider
                        before using any of the protocols presented on this website and/or in the product sold here. Neither BuyGoods nor the author are engaged in rendering medical or similar professional services
                        or advice via this website or in the product, and the information provided is not intended to replace medical advice offered by a physician or other licensed healthcare provider. You should not
                        construe BuyGoods's sale of this product as an endorsement by BuyGoods of the views expressed herein, or any warranty or guarantee of any strategy, recommendation, treatment, action, or
                        application of advice made by the author of the product.
                    </p>
                    <p className="text-gray-400 text-xs mb-4 font-normal">
                        Some names and personal identifying information on this site have been changed to protect the privacy of individuals.
                    </p>

                    {/* Copyright */}
                    <p className="text-gray-400 text-xs font-normal">
                        &copy; {new Date().getFullYear()} Sinoclear.net. All Rights Reserved.
                    </p>
                </div>
            </footer>
            <div className='w-full bg-black   '>
                <div className='flex flex-col gap-5  p-6 pb-0 container max-w-7xl mx-auto px-4'>
                    <div className='flex sm:flex-row flex-col  items-start gap-5'>
                        <img src={BuyGood} />
                        <p className='text-white text-xs'>
                            BuyGoods is the retailer of this product. BuyGoods is a registered trademark of BuyGoods, a Delaware corporation located at 1201 N Orange Street Suite #7223, Wilmington, DE, 19801, USA and used by permission. BuyGoods role as retailer does not constitute an endorsement, approval or review of this product or any claim, statement or opinion used in promotion of this product. Statements on this website have not been evaluated by the Food and Drug Administration. Products are not intended to diagnose, treat, cure or prevent any disease.                    </p>
                    </div>



                </div>

            </div>
        </div>

    );
};

export default Footer;
